import React from "react";
import { FormProvider, useForm } from "react-hook-form";

import { RNBoothSelector } from "../../../components/form-components";
import { FormButtons } from "../../../components";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../helpers";
import { toJS } from "mobx";
const TaskSearchV2 = () => {
  const methods = useForm({
    defaultValues: {
      booth: null,
    },
  });
  const {
    taskManagerStore: { task_filters, update_task_filters },
  } = useStore();
  const handleClear = () => {
    methods.reset({
      booth: {},
    });
    const cleared_task_filters = {
      userList: [],
      pivLevel1: [],
      status: [],
      surveys: [],
    };
    update_task_filters(cleared_task_filters);
  };
  const onSubmit = (data) => {
    if (Object.keys(data.booth).length !== 0) {
      update_task_filters({
        ...toJS(task_filters),
        pivLevel1: [data.booth?.value],
      });
    } else {
      update_task_filters({
        ...toJS(task_filters),
        pivLevel1: [],
      });
    }
  };
  return (
    <div>
      <FormProvider {...methods}>
        <RNBoothSelector
          name={`booth`}
          label="Search Booth"
          isMulti={false}
          selector={"display"}
        />
        <FormButtons
          onSave={methods.handleSubmit(onSubmit)}
          onCancel={() => {
            handleClear();
            methods.handleSubmit(onSubmit)();
          }}
          saveText="Go"
          cancelText="Clear"
        />
      </FormProvider>
      <br />
      <br />
    </div>
  );
};

export default observer(TaskSearchV2);
